import { useCallback, useEffect, useState } from "react";
import { SelectChangeEvent } from "../../../../components/MuiGenerals";
import { useTranslation } from "../../../../hooks";
import { SingleSelection } from "../../../../components/GeneralSelection";
import { useQuery } from "react-query";
import { getCurrencyPair, ICurrencyPair } from "../../../../api/swap";
import { useChains } from "../../../../components/FetchConfig";
import { useZusDialogStore } from "../../../../zustand/store";

interface IProps {
  label?: string;
  value: string;
  chainName: string;
  onChange: (e: SelectChangeEvent) => void;
  onClear: () => void;
}

const CurrencyPairSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear, chainName } = props;

  const [currencyPairsRes, setCurrencyPairsRes] = useState<ICurrencyPair[]>([]);

  const { t } = useTranslation("createSwapRequest");
  const { selectChainByPieces } = useChains();
  const zusDialog = useZusDialogStore();

  const { chain_type, chain_id } = selectChainByPieces({
    chain_name: chainName,
  });

  useQuery({
    queryKey: ["currencyPair", chainName],
    queryFn: async () => {
      zusDialog.openExtra("loadingDialog");
      const res = await getCurrencyPair({
        chainType: Number(chain_type),
        chainId: Number(chain_id),
        // only show enabled
        assetStatus: 1,
      });
      zusDialog.closeExtra();

      return res;
    },
    enabled: Boolean(chainName),
    onSuccess: (data: any) => {
      setCurrencyPairsRes(data);
    },
  });

  const createEnum = (res: ICurrencyPair[]) => {
    const enumData: Record<string, string> = {};

    if (!res) return {};

    res.map((item: ICurrencyPair) => {
      const currencyPair = `${item.asset_name1}/${item.asset_name2}`;
      const key = currencyPair;
      const value = currencyPair;
      enumData[key] = value;

      return key;
    });

    return enumData;
  };

  const enumData = createEnum(currencyPairsRes);

  useEffect(() => {
    if (!chainName) {
      setCurrencyPairsRes([]);
    }
  }, [chainName]);

  return (
    <SingleSelection
      label={label || t("psCurrencyPair")}
      value={value || ""}
      clearSelect={onClear}
      onChange={onChange}
      enumData={enumData}
      nameFn={(item) => item}
    />
  );
};

export default CurrencyPairSingleSelection;
